/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/operators/neg.json`.

import type { PromqlOperatorDefinition } from '../../definition_types';

/**
 * Negates the instant vector or scalar by inverting the sign of each sample value.
 *
 * @example
 * -requests_total
 */
const definition: PromqlOperatorDefinition = {
  type: 'operator',
  operator: '-',
  name: 'neg',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
    {
      params: [
        {
          name: 'field',
          type: 'scalar',
          optional: false,
          description: 'Scalar.',
        },
      ],
      variadic: false,
      returnType: 'scalar',
    },
  ],
  snapshotOnly: false,
};

export default definition;
